var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.number)+". ")]),_c('span',{staticStyle:{"font-size":"15px"},domProps:{"innerHTML":_vm._s(_vm.item)}})])}
var staticRenderFns = []

export { render, staticRenderFns }